import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
// import Backend from 'i18next-locize-backend'
import Backend from 'i18next-http-backend'
//import { DateTime } from 'luxon'
//import LastUsed from 'locize-lastused'
import { locizePlugin } from 'locize'
import { languagesBase } from 'model/ConfigurationMessage'
//import 'locize'
//import { DateTime } from 'luxon'

const locizeOptions = {
  projectId: '29c85baf-f3b3-4b51-83c2-d9c08622e22c',
  apiKey: '8e1d6f51-3f19-4053-999f-cfe894c10349',
  referenceLng: 'en',
  version: 'latest',
}

i18n
  // locize-editor
  // InContext Editor of locize
  .use(locizePlugin)
  // i18next-locize-backend
  // loads translations from your project, saves new keys to it (saveMissing: true)
  // https://github.com/locize/i18next-locize-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    whitelist: Object.values(languagesBase),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: value => {
        return value
      },
    },
    backend: {
      loadPath: '/translations.json',
    },
    locizeLastUsed: locizeOptions,
    saveMissing: false, // you should not use saveMissing in production
  })

/**
 * i18next-browser-languagedetector caches the chosen language in localStorage
 * (key `i18nextLng`) and reads it before the browser locale. That key outlives
 * the session, so on a shared clinic terminal the previous user's choice leaks
 * to the next person — including on unauthenticated pages such as
 * /password-forgotten, which posts `i18n.language` to the server and drives the
 * language of the password-reset email.
 *
 * Clear it on logout so the next user starts from their own browser locale.
 */
export const clearCachedLanguage = () => {
  try {
    window.localStorage.removeItem('i18nextLng')
  } catch (_error) {
    // localStorage can throw in private mode / when storage is disabled
  }
}

export default i18n
